var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandFingerup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M416 149.333a42.524 42.524 0 0 0-23.723 7.211C386.432 139.947 370.581 128 352 128a42.524 42.524 0 0 0-23.723 7.211c-5.845-16.597-21.696-28.544-40.277-28.544a42.321 42.321 0 0 0-21.333 5.739V42.667C266.667 19.136 247.531 0 224 0s-42.667 19.136-42.667 42.667v249.408l-58.645-29.333C113.856 258.325 103.957 256 94.08 256c-22.485 0-40.747 18.283-40.747 40.875 0 10.901 4.245 21.12 11.947 28.821l137.941 137.941C234.389 494.827 275.883 512 320 512c76.459 0 138.667-62.208 138.667-138.667V192c0-23.531-19.136-42.667-42.667-42.667zm21.333 224c0 64.704-52.651 117.333-117.355 117.333-38.421 0-74.517-14.955-101.653-42.133L80.363 310.592c-3.669-3.648-5.696-8.533-5.696-13.845 0-10.709 8.704-19.413 19.413-19.413a42.92 42.92 0 0 1 19.072 4.501l74.091 37.035c3.307 1.643 7.253 1.472 10.368-.469a10.677 10.677 0 0 0 5.056-9.067V42.667c0-11.755 9.557-21.333 21.333-21.333s21.333 9.579 21.333 21.333v202.667c0 5.888 4.779 10.667 10.667 10.667s10.667-4.779 10.667-10.667v-96c0-11.755 9.557-21.333 21.333-21.333s21.333 9.579 21.333 21.333v96c0 5.888 4.779 10.667 10.667 10.667s10.667-4.779 10.667-10.667v-74.667c0-11.755 9.557-21.333 21.333-21.333s21.333 9.579 21.333 21.333v74.667c0 5.888 4.779 10.667 10.667 10.667s10.667-4.779 10.667-10.667V192c0-11.755 9.557-21.333 21.333-21.333s21.333 9.579 21.333 21.333v181.333z",
    fill: "#6c757d",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandFingerup);
export default __webpack_public_path__ + "static/media/hand-fingerup.c30fd0e1c575d4b91c3100637653e8f0.svg";
export { ForwardRef as ReactComponent };